import React, { Component } from 'react'
import { withTranslation } from "react-i18next";
import { ClientService, LocalStorageService } from '../../../services';
import CustomizationView from '../../views/customization/customization.view';
import moment from 'moment';

/**
 * @class CustomizationAction
 * @extends {Component}
 * @status no delete
 * @description Class describing functionality of the customization page for users to personalize the website to their liking
 */
class CustomizationAction extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            clientLogo: {},
            clientLogoUrl: "",
            preferences: [],
            updatedPreferences: [],
            modifiedByUser: "",
            modifiedDate: "",

            showLoadingRequesting: false,
            showWarningRequesting: false,
            showErrorRequesting: false,
            showCompletedRequesting: false,
            messageError: '',
        };
    }

    token = {};
    timezone = "";
    url = process.env.REACT_APP_ETICKET_API;
    localStorageService = new LocalStorageService();
    clientService = new ClientService(this.url);


    /**
     * @description toggles the loading screen for cusomtomization
     * @status no delete
     * @param {*} value
     * @memberof CustomizationAction
     */
    toggleLoadingScreen = (value) => {
        this.setState({
            isLoading: value
        })
    }


    /**
     * @description toggles warning request 
     * @status no delete
     * @param {*} value
     * @param {*} message
     * @memberof CustomizationAction
     */
    toggleWarningRequesting = (value, message) => {
        this.setState(
            {
                showWarningRequesting: value,
                messageError: message,
            },
            () => {
                setTimeout(() => {
                    this.setState({ showWarningRequesting: false, message: "" });
                }, 5000);
            }
        );
    };


    /**
     * @description toggle error request
     * @status no delete
     * @param {*} value
     * @param {*} message
     * @param {*} time
     * @param {*} sendInbox
     * @memberof CustomizationAction
     */
    toggleErrorRequesting = (value, message, time, sendInbox) => {
        this.setState({
            showErrorRequesting: value,
            messageError: message
        }, () => {
            setTimeout(() => {
                this.setState({
                    showErrorRequesting: false,
                })
                if (sendInbox) {
                    this.props.history.push("/");
                }
            }, time)
        })
    }


    /**
     * @status no delete
     * @param {*} value
     * @memberof CustomizationAction
     */
    toggleLoadingRequesting = (value) => {
        this.setState({
            showLoadingRequesting: value,
        });
    };


    /**
     * @status no delete
     * @param {*} value
     * @memberof CustomizationAction
     */
    toggleCompletedRequesting = (value) => {
        this.setState({
            showCompletedRequesting: value,
        });
    }


    /**
     * @description loads the uploaded image onto the page.
     * @status no delete
     * @param {*} event
     * @param {*} key
     * @memberof CustomizationAction
     */
    onImageUpload = (event, key) => {
        if (event.target.files && event.target.files[0]) {
            let type = event.target.files[0].type.split('/')

            if (type[0] === 'image' && event.target.files[0].type !== 'image/tiff') {
                let reader = new FileReader()

                reader.onload = (e) => {
                    let im = new Image()
                    im.src = e.target.result
                    im.onload = () => {
                        this.setState({
                            [key]: {
                                base64: e.target.result,
                                file: event.target.files[0]
                            }
                        })
                    }
                }
                reader.readAsDataURL(event.target.files[0])
                reader = null
            } else {
                this.toggleWarningRequesting(true, "Por favor selecciona una imagen válida para continuar (png, jpg, jpeg).");
            }
        }
    }


    /**
     * @description deletes image on page
     * @status no delete
     * @param {*} key
     * @memberof CustomizationAction
     */
    onImageDelete = (key) => {
        this.setState({
            [key]: {},
        })
    }


    /**
     * @description update the client image uploaded.
     * @status no delete
     * @memberof CustomizationAction
     */
    sendClientImage = async () => {
        let data = new FormData();
        data.append("image", this.state.clientLogo.file);
        const res = await this.clientService.sendClientImage(this.token, data);
        return res.data
    }


    /**
     * @description gets the client image 
     * @status no delete
     * @memberof CustomizationAction
     */
    getClientImage = async () => {
        let result = await this.clientService.getClientImage(this.token);
        if (result.statusCode == 200) {
            if (result?.data?.image) {
                this.localStorageService.setLocalStorageItem('clientLogo', result.data.image)
                this.setState({
                    clientLogoUrl: result.data.image,
                });
            } else {
                this.localStorageService.setLocalStorageItem('clientLogo', '')
            }
        } else {
            throw new Error("Ocurrió un error al obtener tu logo y preferencias")
        }
    }


    /**
     * @description gets all the preference customization data for the user 
     * @status no delete
     * @memberof CustomizationAction
     */
    getPreferecesData = async () => {

        let result = await this.clientService.getClientPreferences(this.token, this.timezone);

        if (result.statusCode == 200) {
            let data = result.data;

            let preferences = [];

            for (let pref of data) {
                if (pref.preferenceId === 0) {
                    this.setState({
                        modifiedByUser: pref.updatedByUser,
                        modifiedDate: pref.updatedDate
                    });
                    continue;
                };

                let current = { ...pref }
                current.booleanValue = (pref.booleanValue != "" && pref.booleanValue) || pref.stringValue != "" || pref.numberValue != "" || pref.dateValue != "";

                preferences.push(current)
            }

            this.setState({
                preferences,
                updatedPreferences: [...preferences]
            });
        } else {
            throw new Error("Ocurrió un error al obtener tus preferencias")
        }
    }


    /**
     * @description sets the user preferences on the page.
     * @status no delete
     * @param {*} preferences
     * @memberof CustomizationAction
     */
    setPreferences = (preferences) => {
        this.setState({
            updatedPreferences: preferences
        });
    }


    /**
     * @description updates the preferences of the user in the database.
     * @status no delete
     * @memberof CustomizationAction
     */
    onSavePreferences = async () => {
        this.toggleLoadingRequesting(true);

        try {
            let prefData = [];

            for (let pref of this.state.updatedPreferences) {
                let og = this.state.preferences.find(og => og.preferenceId == pref.preferenceId);
                if (og.stringValue == pref.stringValue && og.numberValue == pref.numberValue && og.dateValue == pref.dateValue && og.booleanValue == pref.booleanValue) continue; // skip unchanged preferences

                let value = "";

                if (pref.type == "string") value = pref.stringValue;
                if (pref.type == "number") value = pref.numberValue;
                if (pref.type == "date") value = pref.dateValue;

                if (pref.type == "boolean") {
                    value = pref.booleanValue === true;
                } else {
                    if (pref.booleanValue && value == "") { // checked but without input
                        this.toggleWarningRequesting(true, "Debes llenar todos los campos que seleccionaste.");
                        return;
                    }
                }

                prefData.push({
                    id: pref.preferenceId,
                    active: pref.booleanValue,
                    value
                });
            }

            if (this.state.clientLogo.base64) {
                let responseImage = await this.sendClientImage();
                if (responseImage.statusCode != 200) {
                    throw new Error("Ocurrió un error al guardar el logo y tus preferencias.")
                } else {
                    this.localStorageService.setLocalStorageItem('clientLogo', responseImage.data.image);
                    this.setState({
                        clientLogoUrl: responseImage.data.image,
                    });
                    this.props.reloadLogo();
                }
            }

            if (prefData.length) {
                let response = await this.clientService.saveClientPreferences(this.token, prefData);
                if (response.statusCode === 200) {
                    let user = this.localStorageService.getLocalStorageItem("user");

                    this.setState({
                        modifiedDate: moment(new Date()).format("DD-MMM-YYYY"),
                        modifiedByUser: user.userMetaData.userA3Cloud.email,
                    });
                } else {
                    throw new Error("Ocurrió un error al guardar tus preferencias.")
                }
            }
            await this.getPreferecesData();
            this.toggleCompletedRequesting(true)
            this.toggleLoadingRequesting(false);
            setTimeout(() => {
                this.toggleCompletedRequesting(false)
            }, 4000)
        } catch (e) {
            this.toggleErrorRequesting(true, e.message, 4000)
        }
    }

    async componentDidMount() {
        this.toggleLoadingScreen(true);
        try {
            this.timezone = this.localStorageService.getLocalStorageItem("timezone");
            this.token = this.localStorageService.getLocalStorageItem("token").idToken;
            await this.getClientImage();
            await this.getPreferecesData();
            this.toggleLoadingScreen(false);
        } catch (e) {
            this.toggleErrorRequesting(true, e.message, 4000, true)
        }
    }

    render() {
        return (
            <CustomizationView
                {...this.state}
                onImageUpload={this.onImageUpload}
                onImageDelete={this.onImageDelete}
                setPreferences={this.setPreferences}
                onSavePreferences={this.onSavePreferences}

                toggleErrorRequesting={this.toggleErrorRequesting}
                toggleLoadingRequesting={this.toggleLoadingRequesting}
                toggleCompletedRequesting={this.toggleCompletedRequesting}
                toggleWarningRequesting={this.toggleWarningRequesting}
            />
        )
    }
}

export default withTranslation()(CustomizationAction)